import { Model } from '@/models/Model';
import JsonApiResponse from '@/models/JsonApiResponse';
import { QueryClient, QueryKey } from '@tanstack/react-query';
import { ListCacheStrategy } from './BaseListCacheStrategy';

export class SimpleCacheStrategy<T extends Model> extends ListCacheStrategy<T> {
  constructor(queryClient: QueryClient, queryKey: QueryKey) {
    super(queryClient, queryKey);
  }

  get(): T[] | undefined {
    const listParents = this.queryClient.getQueryData<JsonApiResponse<T>>(
      this.queryKey,
    );

    return listParents?.results;
  }

  set(data: T[]): void {
    const listParents = this.getRawData<JsonApiResponse<T>>();
    if (!listParents) return;
    listParents.results = data;
    this.queryClient.setQueryData(this.queryKey, listParents);
  }
  getById = (id: number) => this.get()?.find(item => item.id === id);
}
